(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/components/days-selection.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/components/days-selection.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useContext = _React.useContext;
const _svs$ui$reactForm = svs.ui.reactForm,
  CheckboxGroup = _svs$ui$reactForm.CheckboxGroup,
  Checkbox = _svs$ui$reactForm.Checkbox;
const _svs$numbergames$prod = svs.numbergames.productMapping,
  getBrandingClass = _svs$numbergames$prod.getBrandingClass,
  getProductId = _svs$numbergames$prod.getProductId;
const drawDayLabels = svs.numbergames.draws.drawsUtils.drawDayLabels;
const ProlongContext = svs.numbergames.prolong_game.context.ProlongContext;
const getSelectableDays = (product, drawCount) => Object.entries(drawDayLabels(getProductId(product), {
  drawCount
})).map(_ref => {
  let _ref2 = _slicedToArray(_ref, 2),
    value = _ref2[0],
    label = _ref2[1];
  return {
    value,
    label
  };
});
const DaysSelection = () => {
  const _useContext = useContext(ProlongContext),
    selectedDays = _useContext.selectedDays,
    setSelectedDays = _useContext.setSelectedDays,
    drawCount = _useContext.drawCount,
    productName = _useContext.wager.productName;
  const selectableDays = getSelectableDays(productName, drawCount);
  const branding = getBrandingClass(productName);
  const handleCheckboxChange = e => {
    if (e.target.checked) {
      setSelectedDays(days => [...days, e.target.value]);
    } else {
      setSelectedDays(days => days.filter(day => day !== e.target.value));
    }
  };
  if (selectableDays.length < 2) {
    return null;
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "padding-bottom"
  }, "Speldagar"), React.createElement("div", {
    className: "days-picker padding-bottom"
  }, selectableDays.map(_ref3 => {
    let value = _ref3.value,
      label = _ref3.label;
    return React.createElement(CheckboxGroup, {
      key: value,
      className: "days-picker-item"
    }, React.createElement(Checkbox, {
      branding: branding,
      checked: selectedDays.includes(value),
      onChange: handleCheckboxChange,
      value: value
    }, React.createElement("span", {
      className: "f-capitalize"
    }, label)));
  })));
};
setGlobal('svs.numbergames.prolong_game.components.DaysSelection', DaysSelection);

 })(window);